import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Session} from 'src/app/interfaces/session-data';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import {TransactionService} from 'src/app/services/transaction/transaction.service';
import {PaymentService} from '../../services/payment/payment.service';
import {GoogleAnalyticsService} from '../../services/google-analytics/google-analytics.service';
import {DomSanitizer} from '@angular/platform-browser';
import {TransactionStatus} from '../../interfaces/payment-option';
import {GetPostbackFormDataResponse} from '../../interfaces/PostbackFormData/GetPostbackFormDataResponse';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {SessionService} from '../../services/session/session.service';
import {SecureEftService} from '../../services/secure-eft/secure-eft.service';

@Component({
  selector: 'app-transaction-status',
  templateUrl: './transaction-status.component.html',
  styleUrls: ['./transaction-status.component.scss']
})
export class TransactionStatusComponent implements OnInit, AfterViewInit {

  // loader
  loading = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;
  diameterRedirect = 40;
  @ViewChild('form') form: HTMLFormElement;

  session: Session;
  transactionStatus: TransactionStatus;
  postbackData: GetPostbackFormDataResponse;
  headerColor;
  date = new Date().toJSON();
  cardSvgEl;
  cardType;
  paymentMethodImg;
  paymentMethod;
  transactionFraud;
  persistElChangesInterval;
  count;
  userCancelled;
  errorMessage;
  errorDescription = 'Redirecting you back to the merchant...';
  mobile;
  loadingRedirect = true;
  postBackFailed = false;
  hidePgLogo = false;
  sessionData: Session;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private transactionService: TransactionService,
    private paymentService: PaymentService,
    private googleAnalyticsService: GoogleAnalyticsService,
    public sanitizer: DomSanitizer,
    private breakpointObserver: BreakpointObserver,
    private secureEftService: SecureEftService) {

    breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.paymentMethod = sessionStorage.getItem('selected-payment');
    this.cardType = sessionStorage.getItem('card_type');
    this.session = JSON.parse(sessionStorage.getItem('sessionData'));

  }

  submitForm(form: HTMLFormElement) {
    form.submit();
  }

  setTimeoutForHtmlFormAndSubmit(postBackData: GetPostbackFormDataResponse) {
    if (postBackData && postBackData.url) {
      setTimeout(() => {
        if (postBackData.isShopifyTransaction) {
          console.log('Shopify transaction, redirecting instead of posting form');
          // Check if we're in an iframe and try to break out if needed
          if (this.isInIframe()) {
            try {
              // Try to navigate the top window
              window.top.location.href = postBackData.url;
            } catch (e) {
              // If security restrictions prevent this, fall back to current window
              console.log('Could not navigate top window due to security restrictions:', e);
              window.location.href = postBackData.url;
            }
          } else {
            // Not in iframe, normal navigation
            window.location.href = postBackData.url;
          }
        } else {
          console.log('Post back to merchant');
          if (!document.getElementById('form')) {
            setInterval(() => {
              if (document.getElementById('form')) {
                (document.getElementById('form') as HTMLFormElement).submit();
                // this.loadingRedirect = false;
              }
            }, 2000);
          } else {
            (document.getElementById('form') as HTMLFormElement).submit();
          }
        }
        // this.loadingRedirect = false;
      }, 2000);
    }
  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = true; // this.sessionData.sessionDisplayInformation.hidePgLogo === 'true';
    this.googleAnalyticsService
      .pageViewEvent('virtual.status.component', 'transaction.status');
    this.route.params.subscribe((data) => {
      this.checkCardSvg(data.userCancelled);
      if (data.userCancelled !== 'eft') {
        if (data.userCancelled) {
          this.userCancelled = true;
          this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'), '?userCancelled=true')
            .subscribe((dataPostback: GetPostbackFormDataResponse) => {
              this.postbackData = dataPostback;
              this.googleAnalyticsService
                .pushDirectEvent('virtual.status.postback.data', 'check.postback', JSON.stringify(this.postbackData));
              this.loading = false;
              if (this.postbackData.errorMessage) {
                this.errorMessage = this.postbackData.errorMessage;
              }
              this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
            }, (err) => {
              this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
            });
        } else {
          this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'))
            .subscribe((dataPostback: GetPostbackFormDataResponse) => {
              this.postbackData = dataPostback;
              this.googleAnalyticsService
                .pushDirectEvent('virtual.status.postback.data', 'check.postback', JSON.stringify(this.postbackData));
              this.loading = false;
              if (this.postbackData.errorMessage) {
                this.errorMessage = this.postbackData.errorMessage;
              }
              this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
            }, (err) => {
              this.postBackFailed = true;
              this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
            });
        }
      } else if (data.userCancelled === 'eft') {
        this.secureEftService.getTransactionStatus(sessionStorage.getItem('sessionToken'))
          .subscribe(() => {
            this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'))
              .subscribe((dataPostback: GetPostbackFormDataResponse) => {
                this.postbackData = dataPostback;
                if (this.postbackData.errorMessage) {
                  this.errorMessage = this.postbackData.errorMessage;
                }
                this.loading = false;
                this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
              }, (err) => {
                this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
              });
          });
      } else {
        this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'))
          .subscribe((dataPostback: GetPostbackFormDataResponse) => {
            this.postbackData = dataPostback;
            if (this.postbackData.errorMessage) {
              this.errorMessage = this.postbackData.errorMessage;
            }
            this.loading = false;
            this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
          }, (err) => {
            this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
          });
      }
    }, () => {
      this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'))
        .subscribe((dataPostback: GetPostbackFormDataResponse) => {
          this.postbackData = dataPostback;
          if (this.postbackData.errorMessage) {
            this.errorMessage = this.postbackData.errorMessage;
          }
          this.loading = false;
          this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
        }, (err) => {
          this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
        });
    });

    if (window.location.search.indexOf('fraud') > -1) {
      this.transactionFraud = true;
    }

  }
  private isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we can't access window.top due to security restrictions,
      // we're definitely in an iframe with different origin
      return true;
    }
  }
  ngAfterViewInit() {
    if (document.getElementsByClassName('header-container')[0]) {
      this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;
    }

    // setTimeout(() => {
    //   console.log(document.getElementById('card-page-container'), document.getElementById('credit__card__front').style.display);
    //   document.getElementById('credit__card__front').style.display = 'flex';
    //   console.log(document.getElementById('card-page-container'), document.getElementById('credit__card__front').style.display);
    //   document.getElementById('credit__card__back').style.display = 'none';
    // }, 5000);

  }

  // attemptPersistenceOfElementChangesUntilChanged(el: HTMLElement, text: string) {
  //   this.persistElChangesInterval = setInterval(() => {
  //     console.log('Persist!!');
  //     el.textContent = text;
  //     this.count += 1;
  //     if (this.count === 10) {
  //       clearInterval(this.persistElChangesInterval);
  //     }
  //   }, 100);
  // }

  checkCardSvg(userCancelled: boolean) {
    this.cardSvgEl = sessionStorage.getItem('card_svg_el');
    // if (sessionStorage.getItem('card_svg_front')) {
    //   const domParser = new DOMParser();
    //   const parsedCardEl = domParser.parseFromString(this.cardSvgEl, 'text/html');
    //   console.log(parsedCardEl);
    //   this.getCardFrontInterval = setInterval(() => {
    //     console.log('interval!');
    //   }, 100);
    // }
    // sessionStorage.setItem('card_svg_front', document.getElementById('credit__card__front').outerHTML);
    // if (userCancelled) {
    //   this.attemptPersistenceOfElementChangesUntilChanged(document.getElementById('svgname'), 'JOHN DOE');
    //   this.attemptPersistenceOfElementChangesUntilChanged(document.getElementById('svgnumber'), '0123 4567 8910 1112');
    //   this.attemptPersistenceOfElementChangesUntilChanged(document.getElementById('svgexpire'), '00/00');
    // }

  }

  postBackResultSuccessful(result: string) {
    return parseInt(result, 10) > -1;
  }
}
